export async function wait(ms: number): Promise<void> {
  return new Promise(res => {
    setTimeout(
      () => {
        res();
      },
      ms >= 0 ? ms : 0,
    );
  });
}
